import { render, staticRenderFns } from "./article-by-category.vue?vue&type=template&id=a838f080&scoped=true"
import script from "./article-by-category.vue?vue&type=script&lang=js"
export * from "./article-by-category.vue?vue&type=script&lang=js"
import style0 from "./article-by-category.vue?vue&type=style&index=0&id=a838f080&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a838f080",
  null
  
)

export default component.exports